<div class="customer-avatar-status" [class]="'customer-avatar-status--' + status()">
    @if (status() === 'hot-prospect') {
        <pnyc-icon class="customer-avatar-status-icon" [iconName]="'flame'">
        </pnyc-icon>
    }
</div>
